import React from "react";
import { Link } from "react-router-dom";
import MemberAvatar from "@/components/common/MemberAvatar";

/**
 * Compact inbox preview (first four conversations) on the member dashboard.
 *
 * Extracted verbatim from src/pages/Dashboard.jsx during the code-quality pass:
 * markup, copy, data-testids and behaviour are unchanged.
 */
export default function MessagesPreview({ convos }) {
  return (
    <section className="sm-card p-6 bg-white">
      <div className="flex items-center justify-between">
        <h2 className="font-display text-xl font-bold text-[#1F2A2E]">Messages</h2>
        <Link to="/messages" className="text-sm font-semibold text-[#1F6F78]">
          Open inbox
        </Link>
      </div>
      {convos.conversations.length === 0 ? (
        <p className="mt-3 text-sm text-[#4B5A60]">No conversations yet.</p>
      ) : (
        <ul className="mt-3 divide-y divide-[#E3DED4]">
          {convos.conversations.slice(0, 4).map((c) => (
            <li key={c.id} className="py-3">
              <Link to={`/messages?c=${c.id}`} className="flex items-center gap-3 hover:opacity-80">
                <MemberAvatar user={c.other_user} size={40} />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-[#1F2A2E]">
                    {c.other_user?.display_name}
                  </p>
                  <p className="text-xs text-[#4B5A60] truncate">{c.last_message_preview}</p>
                </div>
                {c.unread_count > 0 && (
                  <span className="px-2 py-0.5 rounded-full bg-[#D07A4A] text-white text-xs font-bold">
                    {c.unread_count}
                  </span>
                )}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
